<template>
  <header id="app-footer">
    <div id="footer-menu">
      <a :href="userGuideURL"> ご利用ガイド </a>
    </div>
    <div id="app-imprint">
      [ lithos-philia.com 2009,2021- 天の根 | リトスピリア ]
    </div>
  </header>
</template>

<script>
export default {
  name: "AppFooter",

  data() {
    return {
      userGuideURL: process.env.VUE_APP_LIT_URL_USER_GUIDE,
    };
  },
};
</script>

<style scoped lang="stylus">

#app-footer
  max-width: 950px
  margin: auto

#app-imprint
  color: #777;

@css {
	#app-footer {
		@apply mt-8 py-4 px-2 text-sm
	}
	#footer-menu {
		@apply text-right
	}
	#app-imprint {
		@apply text-right text-xs
	}

}
</style>
